import storage from '@/utils/storage'
import api from '@/api/authentication'
import commonAPI from '@/api/common'

const state = {
	userInfo: storage.getItem('userInfo') || {},
	noticeListInfo: storage.getItem('noticeListInfo') || [],
}

const mutations = {
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo
		storage.setItem('userInfo', userInfo)
	},
	SET_NOTICELISTINFO: (state, noticeListInfo) => {
		state.noticeListInfo = noticeListInfo
		storage.setItem('noticeListInfo', noticeListInfo)
	},
}

const actions = {
	loginAction({ commit }, formInfo) {
		return new Promise((resolve, reject) => {
			api
				.loginAPI(formInfo)
				.then(res => {
					commit('SET_USERINFO', res.data.userinfo)
					return resolve(res)
				})
				.catch(error => {
					return reject(error)
				})
		})
	},
	tokenLoginAction({ commit }, token) {
		return new Promise((resolve, reject) => {
			api
				.tokenLoginAPI(token)
				.then(res => {
					commit('SET_USERINFO', res.data.userinfo)
					
					return resolve(res)
				})
				.catch(error => {
					return reject(error)
				})
		})
	},
	logoutAction({ commit }, params) {
		return new Promise((resolve, reject) => {
			api
				.logoutAPI(params)
				.then(res => {
					commit('SET_USERINFO', {})
					storage.clearAllSessionStorage()
					return resolve(res)
				})
				.catch(error => {
					return reject(error)
				})
		})
	},
	getUserNoticeList({ commit }, params) {
		
		return new Promise((resolve, reject) => {
			commonAPI
				.userNoticeList(params)
				.then(res => {
					commit('SET_NOTICELISTINFO', res.data)
					
					return resolve(res)
				})
				.catch(error => {
					return reject(error)
				})
		})
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
